import React from 'react';
import ResponsiveWrapper from '../../components/ResponsiveWrapper';
import { Statistic } from './index';
import MobileStatistic from './MobileStatistic';

const ResponsiveStatistic = ({ systemMetrics }) => {
  return (
    <ResponsiveWrapper
      mobile={<MobileStatistic systemMetrics={systemMetrics} />}
      desktop={<Statistic systemMetrics={systemMetrics} />}
    />
  );
};

export default ResponsiveStatistic;